// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"5e45d825e473aef24a70","873":"0b9aa20168f35cbdb114"}[chunkId] + ".js";
};